<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>查询条件</div>
          </div>
          <el-form :inline="true" :model="accountWithdrawalApplyManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="accountWithdrawalApplyManageInfo.conditions.applyUserName" placeholder="请输入申请人名称"
                clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="accountWithdrawalApplyManageInfo.conditions.applyUserTel" placeholder="请输入申请人电话"
                clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="accountWithdrawalApplyManageInfo.conditions.bankCode" placeholder="请输入银行账号"
                clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryAccountWithdrawalApplyMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetAccountWithdrawalApplyMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>账户提现</div>
          </div>
          <el-table :data="accountWithdrawalApplyManageInfo.accountWithdrawalApplys" border style="width: 100%">
            <el-table-column prop="amount" label="提现金额" align="center" />
            <el-table-column prop="applyUserName" label="申请人名称" align="center" />
            <el-table-column prop="applyUserTel" label="申请人电话" align="center" />
            <el-table-column prop="bankName" label="开户行" align="center" />
            <el-table-column prop="bankCode" label="账户" align="center" />
            <el-table-column prop="context" label="申请说明" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="accountWithdrawalApplyManageInfo.total"
            class="pagination" />
        </el-card>
      </el-col>
    </el-row>

    <edit-account-withdrawal-apply ref="editAccountWithdrawalApply" @refresh="_queryAccountWithdrawalApplyMethod()" />
    <delete-account-withdrawal-apply ref="deleteAccountWithdrawalApply" @refresh="_queryAccountWithdrawalApplyMethod()" />
  </div>
</template>

<script>
import { listAccountWithdrawalApply } from '@/api/goods/accountWithdrawalApplyApi'
import EditAccountWithdrawalApply from '@/components/goods/editAccountWithdrawalApply'
import DeleteAccountWithdrawalApply from '@/components/goods/deleteAccountWithdrawalApply'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AccountWithdrawalApplyManage',
  components: {
    EditAccountWithdrawalApply,
    DeleteAccountWithdrawalApply
  },
  data() {
    return {
      accountWithdrawalApplyManageInfo: {
        accountWithdrawalApplys: [],
        total: 0,
        conditions: {
          applyUserName: '',
          bankCode: '',
          applyUserTel: '',
          state: '',
          objId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.accountWithdrawalApplyManageInfo.conditions.objId = getShopId()
    this._listAccountWithdrawalApplys(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAccountWithdrawalApplys(this.currentPage, this.pageSize)
    },
    async _listAccountWithdrawalApplys(page, rows) {
      try {
        const params = {
          ...this.accountWithdrawalApplyManageInfo.conditions,
          page,
          row: rows
        }
        const res = await listAccountWithdrawalApply(params)
        this.accountWithdrawalApplyManageInfo.accountWithdrawalApplys = res.data
        this.accountWithdrawalApplyManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _queryAccountWithdrawalApplyMethod() {
      this.currentPage = 1
      this._listAccountWithdrawalApplys(this.currentPage, this.pageSize)
    },
    _resetAccountWithdrawalApplyMethod() {
      this.accountWithdrawalApplyManageInfo.conditions = {
        applyUserName: '',
        bankCode: '',
        applyUserTel: '',
        state: '',
        objId: getShopId()
      }
      this.currentPage = 1
      this._listAccountWithdrawalApplys(this.currentPage, this.pageSize)
    },
    _openEditAccountWithdrawalApplyModel(row) {
      this.$refs.editAccountWithdrawalApply.open(row)
    },
    _openDeleteAccountWithdrawalApplyModel(row) {
      this.$refs.deleteAccountWithdrawalApply.open(row)
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>